import { render, staticRenderFns } from "./JournalFiltersModule.vue?vue&type=template&id=d12e407e&"
import script from "./JournalFiltersModule.ts?vue&type=script&lang=ts&"
export * from "./JournalFiltersModule.ts?vue&type=script&lang=ts&"
import style0 from "./JournalFiltersModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports